<template>
  <div class="mobile-menu-component">
    <div class="container">
      <div class="mt-5 text-center">
        <div class="row">
          <div class="col-6">
            <div class="dropdown" @click="toggleDropdown" :class="toggled ? 'show' : ''">
              <button class="btn btn-toggle dropdown-toggle" type="button">
                Types
              </button>
              <div class="dropdown-menu"  :class="toggled ? 'show' : ''">
                <a class="dropdown-item" v-for="(menuItem, index) in menuItems" :key="index" :href="`/products/${menuItem.slug}`">{{ menuItem.name }}</a>
              </div>
            </div>
          </div>
          <div class="col-6">
            <select name="categories" class="form-control mobile-select" @change="getSort" v-model="sort">
              <option value="" selected>Sort By</option>
              <option value="0">Alphabetical (A-Z)</option>
              <option value="1">Alphabetical (Z-A)</option>
              <option value="2">Price (Low to High)</option>
              <option value="3">Price (High to Low)</option>
              <option value="4">Oldest to Newest</option>
              <option value="5">Newest to Oldest</option>
            </select>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MobileMenu',
  data() {
    return {
      toggled: false,
      selectedItem: undefined,
      sort: ''
    }
  },
  props: {
    menuItems: Array
  },
  methods: {
    getSort() {
      this.$emit('get-sort', this.sort);
    },
    toggleDropdown() {
      if (this.toggled) {
        this.toggled = false;
      } else {
        this.toggled = true;
      }
    },
    onClose() {
      this.toggled = false;
    },
  }
};
</script>

<style lang="sass" scoped>
.mobile-select
  display: block
  font-size: 16px
  text-transform: uppercase
  font-weight: bold
  color: $dutche-primary-violet
  line-height: 1.3
  padding: .6em 1.4em .5em .8em
  width: 100%
  max-width: 100%
  box-sizing: border-box
  margin: 0
  border: 1px solid #aaa
  box-shadow: 0 1px 0 1px rgba(0,0,0,.04)
  border-radius: .2em
  -moz-appearance: none
  -webkit-appearance: none
  appearance: none
  background-color: #fff
  background-image: url('data:image/svg+xmlcharset=US-ASCII,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%22292.4%22%20height%3D%22292.4%22%3E%3Cpath%20fill%3D%22%23007CB2%22%20d%3D%22M287%2069.4a17.6%2017.6%200%200%200-13-5.4H18.4c-5%200-9.3%201.8-12.9%205.4A17.6%2017.6%200%200%200%200%2082.2c0%205%201.8%209.3%205.4%2012.9l128%20127.9c3.6%203.6%207.8%205.4%2012.8%205.4s9.2-1.8%2012.8-5.4L287%2095c3.5-3.5%205.4-7.8%205.4-12.8%200-5-1.9-9.2-5.5-12.8z%22%2F%3E%3C%2Fsvg%3E'),linear-gradient(to bottom, $dutche-primary-yellow 0%,$dutche-primary-yellow 100%)
  background-repeat: no-repeat, repeat
  background-position: right .7em top 50%, 0 0
  background-size: .65em auto, 100%
.mobile-select::-ms-expand
  display: none
.mobile-select:hover
  border-color: $white
.mobile-select:focus
  border-color: $white
  box-shadow: 0 0 1px 3px rgba(59, 153, 252, .7)
  box-shadow: 0 0 0 3px -moz-mac-focusring
  color: $dutche-primary-violet
  outline: none
.mobile-select option
  font-weight: bold
  color: $dutche-primary-violet

.mobile-menu-component
  button.btn-toggle
    width: 100%
    background-color: $dutche-primary-yellow
    border: none
    color: $dutche-primary-violet
    font-weight: bold
    text-transform: uppercase
</style>
